function updateFlushOffset() {
    const header = document.querySelector('.header')
    if (header) {
        document.documentElement.style.setProperty(
            '--header-height',
            `${header.offsetHeight}px`
        )
    }
}

updateFlushOffset()

const alerts = Array.from(document.querySelectorAll('.js-alert'))

alerts.forEach((alert) => {
    const dismisser = alert.querySelector('.js-dismiss')
    if (!dismisser) return

    dismisser.addEventListener('click', () => {
        alert.parentNode.removeChild(alert)
        updateFlushOffset()
    })
})
